import React from 'react'
import './footer.scss';
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<footer>
			<div className='footer-wrapper'>
					<small>&copy; 2023-2026 NEXARK</small>
					<Link className='discord-link' title='NEXARK Discord' to={'https://discord.gg/E5gPRwfvWS'} rel='noreferrer noopener' target='_blank'><i className="bi bi-discord"></i></Link>
					<small>mit <span style={{color: 'red'}}>♥️</span> erstellt von <Link className='dev-link' to={'https://github.com/RealMahu'} rel='noreferrer noopener' target='_blank'>RealMahu</Link></small>
			</div>
		</footer>
	)
}

export default Footer